import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import saccoLoanService from "@saccoLoanService";

/**
 * Fetches all loan repayments for a given membership (across all loans).
 * Used to compute outstanding loan balance in SaccoMetrics.
 */
export default function useFetchSaccoLoanMembershipRepayments(membershipId: string) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['sacco_membership_repayments', membershipId],
    queryFn: async () => {
      return await saccoLoanService.fetchRepayments(user.id, membershipId);
    },
    enabled: !!user && !!membershipId,
  });
}
